<script lang="ts">
	import { home_data, user_settings } from 'src/stores/account/user';
	import { handleNewsLetterPermissions } from '../components/Settings/AccountSettings/Notification/user_permissions_helper';
	import { format } from '../services/i18n';
	import { Text, Button, Modal, Container, Checkbox } from '@Shelly/shelly-design-system';
	import { save_home } from '../helpers/home_helpers';

	export let showModal = false;

	let newsletterCheck = $user_settings.newsletter;

	if (newsletterCheck == -1) {
		newsletterCheck = 0;
	}

	const updateHomeData = () => {
		// const homeDataLayout = $home_data.showNewsletter || {};

		save_home('newsletterPrompt', {
			seen: true,
		});

		home_data.set({
			...$home_data,
			newsletterPrompt: {
				seen: true,
			},
		});
	};

	const handleCloseModal = () => {
		showModal = false;
		updateHomeData();
	};

	const handleSave = () => {
		handleNewsLetterPermissions(newsletterCheck);
		handleCloseModal();
	};

	const handleCancel = () => {
		// handleNewsLetterPermissions(0);
		handleCloseModal();
	};
</script>

<Modal on:close={handleCancel} {showModal} title="Subscribe for Newsletter">
	<Container slot="content" padding="0">
		<div class="text-center">
			<img class="mb-m" src="images/newsletter.svg" alt="Newsletter" />
			<Text class="mb-s" styleType="h1">Don’t Miss Out!</Text>
			<Text class="mb-s"
				>Get exclusive offers, product releases & updates straight to your inbox.</Text
			>
		</div>
		<Checkbox id="newsletter-checkbox" size="l" class="mb-m" bind:checked={newsletterCheck}>
			{$format('checkbox_newsletter', {
				default:
					'I want to receive exclusive deals and latest information about Shelly products and Services on my e-mail.',
			})}
		</Checkbox>
		<div class="text-center">
			<Button class="width-md-s width-sm-full mb-m" on:click={handleSave}>Save</Button>
			<div>
				<Text class="d-inline-flex text-primary cursor-pointer" on:click={handleCancel}
					>Cancel</Text
				>
			</div>
		</div>
	</Container>
</Modal>
